/** @format */

import React, {useState, useEffect} from 'react';
import SuperAgent from 'superagent';
import {Loading} from 'frontier-utilities';

export const OrganizationalRelationships = () => {
    const [relationships, setRelationships] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRelationships = async () => {
            try {
                setLoading(true);
                const response = await SuperAgent.get(
                    '/account/users/organizational-relationships'
                ).set('accept', 'application/json');
                setRelationships(response.body.relationships || {});
                setLoading(false);
            } catch (err) {
                console.error('Error fetching organizational relationships:', err);
                setError('Failed to load organizational relationships data.');
                setLoading(false);
            }
        };

        fetchRelationships();
    }, []);

    if (loading) {
        return <Loading message="Loading organizational relationships..." />;
    }

    if (error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    // If no relationships data or user doesn't have workrouter details
    if (!relationships || Object.keys(relationships).length === 0) {
        return null;
    }

    return (
        <>
            <hr />
            <h3 className="account-preferences-section-10mc__heading">
                Organizational Relationships
            </h3>
            <div className="account-preferences-section-10mc__row">
                <div className="w-100">
                    <div className="card mb-3">
                        <div className="card-body">
                            {relationships.user && (
                                <div className="mb-3">
                                    <h5 className="mb-1">Your Information</h5>
                                    <p className="mb-0">
                                        <strong>Name:</strong> {relationships.user.name}
                                    </p>
                                    {relationships.user.job_title && (
                                        <p className="mb-0">
                                            <strong>Job Title:</strong>{' '}
                                            {relationships.user.job_title}
                                        </p>
                                    )}
                                </div>
                            )}

                            {relationships.supervisor && (
                                <div className="mb-3">
                                    <h5 className="mb-1">Your Supervisor</h5>
                                    <p className="mb-0">
                                        <strong>Name:</strong> {relationships.supervisor.name}
                                    </p>
                                    {relationships.supervisor.job_title && (
                                        <p className="mb-0">
                                            <strong>Job Title:</strong>{' '}
                                            {relationships.supervisor.job_title}
                                        </p>
                                    )}
                                </div>
                            )}

                            {relationships.reviewer &&
                                relationships.reviewer.id !== relationships.supervisor?.id && (
                                    <div>
                                        <h5 className="mb-1">Your Reviewer</h5>
                                        <p className="mb-0">
                                            <strong>Name:</strong> {relationships.reviewer.name}
                                        </p>
                                        {relationships.reviewer.job_title && (
                                            <p className="mb-0">
                                                <strong>Job Title:</strong>{' '}
                                                {relationships.reviewer.job_title}
                                            </p>
                                        )}
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
